import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
//import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./Redux/store";
import { setupAxiosInterceptors } from "./axios/axiosInstance";
import { AppTheme } from "./theme/JaziTheme";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import { suppressResizeObserverLoopError } from "./utils/suppressResizeObserverLoop";

suppressResizeObserverLoopError();
setupAxiosInterceptors(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AppTheme>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </AppTheme>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
